'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _navigationItem = require('./navigationItem');

var _navigationItem2 = _interopRequireDefault(_navigationItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  temporary: _propTypes2.default.bool
};

var Navigation = function Navigation(_ref) {
  var className = _ref.className,
      children = _ref.children,
      temporary = _ref.temporary,
      otherProps = _objectWithoutProperties(_ref, ['className', 'children', 'temporary']);

  var navigationItems = _react2.default.Children.map(children, function (item) {
    return (0, _navigationItem2.default)(item, temporary);
  });

  return _react2.default.createElement(
    'nav',
    _extends({
      className: (0, _classnames2.default)('mdc-list', className)
    }, otherProps),
    navigationItems
  );
};
Navigation.propTypes = propTypes;
exports.default = Navigation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Drawer/Navigation.js
// module id = 302
// module chunks = 0